import type { IconSvgObject } from './types';

const ShoppingBasket02Icon: IconSvgObject = [
  ["path", { d: "M5.25469 20.2828C5.39545 21.2681 6.23929 22 7.23459 22H16.7654C17.7607 22 18.6046 21.2681 18.7453 20.2828L20.5 8H3.5L5.25469 20.2828Z", stroke: "currentColor", strokeLinejoin: "round", strokeWidth: "1.5", key: "0" }],
  ["path", { d: "M7.5 8V6.5C7.5 4.01472 9.51472 2 12 2C14.4853 2 16.5 4.01472 16.5 6.5V8", stroke: "currentColor", strokeLinejoin: "round", strokeWidth: "1.5", key: "1" }],
  ["path", { d: "M5 18H19", stroke: "currentColor", strokeWidth: "1.5", key: "2" }]
];

export default ShoppingBasket02Icon;
